import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home'
import aboutus from '@/pages/aboutus'
import services from '@/pages/services'
import prices from '@/pages/prices'
import pricescsv from '@/pages/prices-csv'
import test from '@/pages/test'
import contact from '@/pages/contact'
// import reviews from '@/pages/reviews'
import portfolio from '@/pages/portfolio'
import kup from '@/pages/kup/home'
import tutorial from '@/pages/kup/tutorial'
import cookies from '@/pages/cookies'
import psiho from '@/pages/psiho/psihotest'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Naslovna',
      component: home
    },
    {
      path: '/o-nama',
      name: 'O Nama',
      component: aboutus
    },
    {
      path: '/usluge',
      name: 'Usluge',
      component: services
    },
    {
      path: '/cijene',
      name: 'Cijene',
      component: prices
    },
    {
      path: '/cijene-csv',
      name: 'Cijene CSV',
      component: pricescsv
    },
    {
      path: '/kontakt',
      name: 'Koktakt',
      component: contact
    },
    // {
    //   path: '/recenzije',
    //   name: 'Recenzije',
    //   component: reviews
    // },
    // {
    //   path: '/portfolio',
    //   name: 'Portfolio',
    //   component: portfolio
    // },
    {
      path: '/kup',
      name: 'Kup',
      component: kup
    },
    {
      path: '/izjava-o-kolacicima',
      name: 'Izjava o kolačićima',
      component: cookies
    },
    {
      path: '/kup/uputa',
      name: 'Tutorial',
      component: tutorial
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: login
    // },
    {
      path: '/test',
      name: 'test',
      component: test
    },
    {
      path: '/psiho-test',
      name: 'psiho',
      component: psiho
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js